import { Slide, Snackbar } from '@mui/material';
import { Alert } from '@mui/lab';
import { useTranslation } from 'react-i18next';

function TransitionDown(props) {
    return <Slide {...props} direction="left" />;
}

const ModalSuccess = ({ object, action, open, handleClose }) => {
    const { t } = useTranslation();
    return (
        <Snackbar
            autoHideDuration={5000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            onClose={handleClose}
            TransitionComponent={TransitionDown}
        >
            <Alert severity="success" sx={{ width: '100%' }}>
                {`${object} ${action} ${t('successfully')}`}
            </Alert>
        </Snackbar>
    );
};

export default ModalSuccess;
